import { Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';
import { Patient } from '../patients/patient';
import { takeUntil } from 'rxjs/operators';
import { GastroFormsService } from '../gastro-forms.service';


@Component({
    selector: 'app-waiting-list',
    templateUrl: './waiting-list.component.html',
    styleUrls: ['./waiting-list.component.scss'],
    standalone: false
})
export class WaitingListComponent implements OnInit {
  awlStatus = 'Waiting'
  awlList=[]
  private destroy$ = new Subject();
  openConsentForm=false

  constructor(public loginService: LoginService, public patservice: PatientsService,public gfs:GastroFormsService) { }

  ngOnInit(): void {
    this.loginService.loginMissing();
    this.getWAL()
    this.patservice.awlIncomming.pipe(takeUntil(this.destroy$)).subscribe(()=>{
        this.getWAL();
    });
  }

  getWAL() {
    this.patservice.openWebSocket(this.loginService.ClinicID);
    this.patservice.getAWL(this.awlStatus, 'All',{ uid:this.loginService.doctor,start:undefined,end:undefined }).subscribe((patients: Patient[]) => {
      this.awlList=[]
      if (patients.length > 0) {
        this.awlList = patients;
      }

  })

}

close(toclose: boolean) {
  this.openConsentForm=false
}

ngOnDestroy(): void {
 this.destroy$.next(undefined)
  this.patservice.closeWebSocket();
  this.awlList=[]
}

loadConsent(awlId){
  // לבדוק אחרכך איך לא לשמור אותם , בלי לחיצה על כפתור הsave אולי הוספת משתנה נוסף חדש
  this.gfs.loadForm(false,true,awlId,false,"Form of Consent")
}

printConsent(){
    window.open('api/printpdf/'+this.gfs.FormIndex+'/'+this.patservice.currentPatient.PID+'/'+'he-IL'+'/'+ 'n' +'/'+  'n'+ '/'+ 'simple'+ '/'+ '2' + '/' + 'y' + '/' + 'n'+'/y'); 
}




}
